/** Gets selected ReceiptItemTable row styles of outline. */
export const getSelectedRowOutlineStyles = (theme) => ({
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: '-2px',
    borderRadius: `var(--gp-radius-md)`,
});
